import { Methods } from '@newview/infrastructure';
import { DbCenterBaseApi } from "../DbCenterBaseApi";

export class JobinfoApi extends DbCenterBaseApi {

  public get ControllerName(): any {
    return 'jobinfo';
  }

  /**
   * 查询分页列表
   */
  public pageList(start, length, jobGroup, triggerStatus, jobDesc, executorHandler, author) {
    return this.send({ start: start, length: length, jobGroup: jobGroup, triggerStatus: triggerStatus, jobDesc: jobDesc, executorHandler: executorHandler, author: author }, "pageList", Methods.GET);
  }

  /**
   * 添加任务
   */
  public add(param) {
    return this.send(param, "add", Methods.POST)
  }
  /**
   * 修改任务
   */
  public update(param) {
    return this.send(param, "update", Methods.POST)
  }
  /**
   * 删除任务
   */
  public remove(id) {
    return this.send({ id: id }, "remove", Methods.GET)
  }

  /**
* 启动
*/
  public start(id) {
    return this.send({ id: id }, "start", Methods.GET)
  }
  /**
    * 停止
    */
  public stop(id) {
    return this.send({ id: id }, "stop", Methods.GET)
  }
    /**
    * 执行一侧
    */
     public trigger(id,executorParam,addressList) {
      return this.send({ id: id,executorParam:executorParam,addressList:addressList }, "trigger", Methods.GET)
    }
  



}